// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wikiLog[data-v-1e65853c]{padding:8px 8px 8px 0;display:flex;flex-direction:row;border-bottom:1px solid #ddd}.wikiLog__avatar[data-v-1e65853c]{width:40px;height:40px;border-radius:50%;margin-right:8px}.wikiLog__content[data-v-1e65853c]{width:100%}.wikiLog__details[data-v-1e65853c]{display:flex;justify-content:space-between}@media (max-width: 599px){.wikiLog__details[data-v-1e65853c]{flex-direction:column}}\n", ""]);
// Exports
module.exports = exports;
